// ── Placeholder ───────────────────────────────────────────────────────────────
//
// Diagonal-line pattern shown in place of an image object that has no source.

interface IPlaceholder { id: string; width: number; height: number }

export function Placeholder(P: IPlaceholder)
{
	const patId = `ph-${P.id}`;
	return (
		<>
			<defs>
				<pattern id={patId} width="10" height="10" patternUnits="userSpaceOnUse">
					<line x1="0" y1="10" x2="10" y2="0" stroke="#555" stroke-width="1.5"/>
				</pattern>
			</defs>
			<rect x={0} y={0} width={P.width} height={P.height} fill="#2a2a2a"/>
			<rect x={0} y={0} width={P.width} height={P.height} fill={`url(#${patId})`}/>
			<rect x={0} y={0} width={P.width} height={P.height} fill="none" stroke="#555" stroke-width="1"/>
		</>
	)
}
